{
  "nav": "机房",
  "title": "机房",
  "subtitle": "机房管理站回报的网络、Wi-Fi 基站、服务器与 NAS 状态（只能查看）。",
  "loading": "读取中…",
  "not_found": "找不到可以查看的机房。",
  "col": {
    "site": "地点",
    "station": "机房管理站",
    "online": "连线"
  },
  "online": "在线",
  "offline": "离线",
  "tab": {
    "overview": "总览",
    "router": "路由器",
    "ap": "Wi-Fi 基站",
    "servers": "服务器",
    "nas": "NAS"
  },
  "tool": {
    "site.status": "总览",
    "net.devices": "已连接设备",
    "net.wan": "对外网络",
    "net.wifi": "Wi-Fi",
    "net.traffic": "流量",
    "net.dhcp.list": "固定 IP",
    "net.forward.list": "端口转发",
    "net.logs": "日志",
    "ap.status": "状态",
    "ap.clients": "已连接客户端",
    "ap.wifi": "Wi-Fi 设置",
    "srv.health": "服务器",
    "nas.health": "NAS"
  },
  "refresh": "刷新",
  "running": "查询中…",
  "updated": "更新于 {{at}}",
  "wait": "（稍候 {{s}} 秒）",
  "error": "查询失败：{{code}}",
  "run_state": "查询没有完成：{{state}} {{code}}",
  "no_resources": "这台机房管理站没有登记这类设备。"
}
